/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.querySelectorAll('.variant-picker').forEach(picker => {
  picker.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      const productId = picker.dataset.productId;

      // Aktiven Button markieren
      picker.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Preis aktualisieren
      const priceEl = document.querySelector(`.variant-price-display[data-product-id="${productId}"]`);
      if (priceEl) {
        priceEl.textContent = btn.dataset.price;
      }

      // Bild aktualisieren (falls die Größe ein eigenes Foto hat)
      const card = picker.closest('.grid-item.product-item');
      const imgEl = card ? card.querySelector('.product-item__bg[data-product-image-default] img') : null;
      if (imgEl && btn.dataset.imageSrc) {
        imgEl.src = btn.dataset.imageSrc;
        if (btn.dataset.imageSrcset) {
          imgEl.srcset = btn.dataset.imageSrcset;
        } else {
          imgEl.removeAttribute('srcset');
        }
      }
    });
  });
});
// Restock Countdown (72h)
document.querySelectorAll('.restock-countdown').forEach(function(el) {
  var since = parseInt(el.dataset.restockSince, 10) * 1000;
  var restock = since + (72 * 60 * 60 * 1000);
  var display = el.querySelector('.countdown-display');
  function update() {
    var diff = restock - Date.now();
    if (diff <= 0) { display.textContent = 'Bald verfügbar'; return; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    display.textContent = h + 'Std ' + m + 'Min';
  }
  update();
  setInterval(update, 60000);
});

// Button Styling Fix
(function() {
  var style = document.createElement('style');
  style.textContent = '.product-soldout-notification .btn { width: auto !important; padding: 10px 20px !important; font-size: 0.85em !important; white-space: nowrap !important; }';
  document.head.appendChild(style);
})();

// Produktseite: Standard ist immer die größte Größe (höchster Preis), unabhängig vom Lagerbestand.
// Gilt nur, wenn die URL keine bestimmte Variante (?variant=...) nennt.
// Ehrlich: Waehrend eines Events (Gratis-Probe/Verschenken, Token im Browser) uebernimmt snippets/ehrlich-fokus-head die Variantenwahl;
// dieser Standard greift dann nicht, damit sich die beiden Skripte nicht gegenseitig ueberschreiben.
(function() {
  var comp = document.querySelector('product-component');
  var pj = comp ? comp.querySelector('[data-product-json]') : null;
  if (!pj || /[?&]variant=/.test(location.search)) return;
  try {
    var pt = localStorage.getItem('ehrlich_probe_token');
    if ((pt && localStorage.getItem('ehrlich_probe_used') !== '1') || localStorage.getItem('ehrlich_kreis_token')) return;
  } catch (e) {}
  var product;
  try { product = JSON.parse(pj.textContent); } catch (e) { return; }
  if (!product.variants || product.variants.length < 2 || product.options.length !== 1) return;
  var largest = product.variants.reduce(function(a, b) { return b.price > a.price ? b : a; });
  function selectLargest() {
    var target = null;
    comp.querySelectorAll('input[name^="options"]').forEach(function(r) {
      if (r.value === largest.options[0]) target = r;
    });
    if (!target || target.checked) return;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (customElements.get('product-form')) {
    selectLargest();
  } else {
    customElements.whenDefined('product-form').then(function() { setTimeout(selectLargest, 0); });
  }
})();


  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();